<template>
  <section class="container-fluid padded exp-mt max-w">
    <div class="row">
      <div class="col-lg-6 d-flex flex-column justify-content-center center">
        <h2 class="featured-exp-call-out-title">{{ title }}</h2>
        <p v-html="description"></p>
      </div>
    </div>
    <div class="cuisine-grid">
      <router-link v-for="(cuisine, index) in cuisines" :key="`${cuisine.name}-${index}`" class="cuisine-item"
        :to="`${cuisine.cuisine_url}`">
        <b-img-lazy :src="cuisine.image" class="cuisine-image cover" :alt="cuisine.name" role="presentation" />
        <div class="overlay cover"></div>
        <div class="cover">
          <div class="text-wrapper">
            <h3 class="cuisine-name">{{ cuisine.name }}</h3>
            <p class="cuisine-description">{{ cuisine.description }}</p>
          </div>
        </div>
      </router-link>
    </div>
  </section>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  data() {
    return {

    };
  },
})

class ExperienceCuisines extends Vue {
  @Prop({ type: String })
  title;

  @Prop({ type: String })
  description;

  @Prop({ type: [Array] })
  cuisines;
}
export default ExperienceCuisines;
</script>
<style lang="scss" scoped>
.padded {
  padding: 0 24px;
}
.exp-mt {
  margin-top: 120px;
}

.max-w {
  max-width: 1278px;
  margin-left: auto;
  margin-right: auto;
}

.center {
  margin: 1rem auto;
}

.cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  .text-wrapper {
    max-width: 172px;
    margin: 0 4px 1rem 1rem;
    border-radius: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
    word-break: break-word;

    p,
    h3 {
      margin: 0;
      text-align: left;
      color: white;
      opacity: 1;
    }

    h3 {
      font-size: 28px;
      font-weight: 400;
      line-height: 38.4px;
      align-items: flex-end;
      height: 70%;
    }

    p {
      font-size: 16px;
      font-weight: 325;
      line-height: 19.2px;
      flex-grow: 1;
      padding-right: 4px;
    }
  }
}

.cuisine-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 0.75rem;
  grid-template-rows: repeat(5, 1fr);

  :nth-of-type(1) {
    grid-row: 1;
    grid-column: 1;
  }

  :nth-of-type(3) {
    grid-row: 2;
    grid-column: 1/3;
  }

  :nth-of-type(4) {
    grid-row: 3;
    grid-column: 1;

    .text-wrapper {
      p {
        flex-grow: unset;
      }

      h3 {
        flex-grow: 1;
      }
    }
  }

  :nth-of-type(5) {
    grid-row: 3;
    grid-column: 2;
  }

  :nth-of-type(6) {
    grid-row: 4;
    grid-column: 1;
  }

  :nth-of-type(7) {
    grid-row: 4;
    grid-column: 2;
  }

  :nth-of-type(8) {
    grid-row: 5;
    grid-column: 1/3;

    .text-wrapper {
      p {
        flex-grow: unset;
      }

      h3 {
        flex-grow: 1;
      }
    }
  }

  .cuisine-item {
    position: relative;
    display: block;
    border-radius: 8px;
    min-height: 190px;
    box-shadow: 0px 4px 4px 0px #00000040;
    overflow: hidden;

    img,
    div {
      border-radius: 8px;
    }

    img {
      object-fit: cover;
      border-radius: 8px;
      background: #0000004D;
      transition: transform 1s ease-in-out;
    }

    &:hover {

      img,
      .overlay {
        transform: scale(1.1);
      }
    }
  }

  .overlay {
    display: block;
    opacity: 0.35;
    background: black;
  }
}
@media screen and (min-width: 430px) {
    .padded {
      padding: 0 48px;
    }
  }
@media screen and (min-width: 811px) {
  .cuisine-grid {
    display: grid;
    grid-template-rows: repeat(2, 1fr);
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 0.75rem;

    :nth-of-type(1) {
      grid-row: 1;
      grid-column: 1;
    }

    :nth-of-type(3) {
      grid-row: 2/3;
      grid-column: 1/3;
    }

    :nth-of-type(4) {
      grid-row: 1/3;
      grid-column: 3;
    }

    :nth-of-type(5) {
      grid-row: 1;
      grid-column: 4/6;
    }

    :nth-of-type(6) {
      grid-row: 2;
      grid-column: 4;
    }

    :nth-of-type(7) {
      grid-row: 2;
      grid-column: 5;
    }

    :nth-of-type(8) {
      grid-row: 1/3;
      grid-column: 6;
    }
  }

  .cover .text-wrapper h3 {
    font-size: 2rem;
  }
}
</style>
